<template>
  <nav class="steps-bar">
    <ul>
      <li v-if="tusDatos()" class="ico1 sel">
        <a href="#"><span>Tus datos2</span></a>
      </li>
      <li v-else class="ico1">
        <span><span>Tus datos</span></span>
      </li>
      <li v-if="tuCoche()" :class="icoAutomovilSelected">
        <a href="#"
          ><span>{{ automovil }}</span></a
        >
      </li>
      <li v-else :class="icoAutomovil">
        <span
          ><span>{{ automovil }}</span></span
        >
      </li>
      <li v-if="tuSeguro()" class="ico3 sel">
        <a href="#"><span>Tu seguro</span></a>
      </li>
      <li v-else class="ico3">
        <span><span>Tu seguro</span></span>
      </li>
      <li v-if="tuPrecio()" class="ico4 sel">
        <a href="#"><span>Tu precio</span></a>
      </li>
      <li v-else class="ico4">
        <span><span>Tu precio</span></span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  store: ["step"],
  data() {
    return {};
  },
  methods: {
    tusDatos() {
      return ["d"].includes(this.step.grupoNavegacion);
    },
    tuCoche() {
      return ["c"].includes(this.step.grupoNavegacion);
    },
    tuSeguro() {
      return ["s"].includes(this.step.grupoNavegacion);
    },
    tuPrecio() {
      return ["p"].includes(this.step.grupoNavegacion);
    }
  },
  computed: {
    automovil() {
      let texto = "Tu ";
      if (this.step.tipoAutomovil) {
        texto += this.step.tipoAutomovil;
      } else {
        texto += " automóvil";
      }
      return texto;
    },
    icoAutomovil() {
      let ico = "ico2";
      if (this.step.tipoAutomovil == "moto") {
        ico = "icoMoto";
      }
      console.log(ico);
      return ico;
    },
    icoAutomovilSelected() {
      let ico = "ico2";
      if (this.step.tipoAutomovil == "moto") {
        ico = "icoMoto";
      }
      ico += " sel";
      console.log("selected " + ico);
      return ico;
    }
  }
};
</script>
